import { inject, Injectable } from "@angular/core";
import { DavesaMockApiService } from "@davesa/lib/mock-api";
import { SearchV2Service } from "app/layout/common/search/search-v2.service";
import { cloneDeep } from "lodash-es";

@Injectable({ providedIn: "root" })
export class SearchMockApi {
  private _searchV2Service = inject(SearchV2Service);
  private _sites: any[] = [];
  private _studies: any[] = [];
  private _participants: any[] = [];

  /**
   * Constructor
   */
  constructor(private _davesaMockApiService: DavesaMockApiService) {
    // Register Mock API handlers
    this.registerHandlers();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Register Mock API handlers
   */
  registerHandlers(): void {
    // // Get the flat navigation and store it
    // const flatNavigation = this._davesaNavigationService.getFlatNavigation(
    //     this._defaultNavigation
    // );

    // -----------------------------------------------------------------------------------------------------
    // @ Search results - GET
    // -----------------------------------------------------------------------------------------------------
    this._davesaMockApiService
      .onPost("api/common/search")
      .reply(({ request }) => {
        // this._searchV2Service.loadFromStorage();
        this._sites = this._searchV2Service.sites();
        this._studies = this._searchV2Service.studies();
        this._participants = this._searchV2Service.participants();

        // Get the search query
        const query = cloneDeep(request.body.query.toLowerCase());

        // If the search query is an empty string,
        // return an empty array
        if (query === "") {
          return [200, { results: [] }];
        }

        // Filter the contacts
        // const sitesResults = cloneDeep(this._sites).filter((site) => site.site_name.toLowerCase().includes(query));

        const sitesResults = this._sites.filter((site) =>
          site.name.toLowerCase().includes(query.toLowerCase())
        );

        const studiesResults = cloneDeep(this._studies).filter((study) =>
          study.name.toLowerCase().includes(query)
        );

        const participantsResults = cloneDeep(this._participants).filter(
          (participant) => participant.name.toLowerCase().includes(query)
        );

        // Prepare the results array
        const results = [];

        // If there are sites results...
        if (sitesResults.length > 0) {
          // Normalize the results
          sitesResults.forEach((result) => {
            // Add a link
            result.link = "/administration/sites/" + result.oid;

            // Add the name as the value
            result.value = result.name;
          });

          // Add to the results
          results.push({
            id: "sites",
            label: "Sites",
            results: sitesResults,
          });
        }

        // If there are sites results...
        if (studiesResults.length > 0) {
          // Normalize the results
          studiesResults.forEach((result) => {
            // Add a link
            result.link = "/apps/studies/" + result.oid;

            // Add the name as the value
            result.value = result.name;
          });

          // Add to the results
          results.push({
            id: "studies",
            label: "Studies",
            results: studiesResults,
          });
        }

        // If there are sites results...
        if (participantsResults.length > 0) {
          // Normalize the results
          participantsResults.forEach((result) => {
            // Add a link
            result.link = "/apps/participants/" + result.oid;

            // Add the name as the value
            result.value = result.name;
          });

          // Add to the results
          results.push({
            id: "participants",
            label: "Participants",
            results: participantsResults,
          });
        }

        // Return the response
        return [200, results];
      });
  }
}
